import Login from './Components/Auth/Login.svelte'
import Dashboard from './Dashboard.svelte'
import Home from './Home.svelte'
import Ahh from './Ahh.svelte'
import Pir from './Pir.svelte'
import Customer from './Customer.svelte'
import Checklist from './Compliance/Checklist.svelte'
import List from './Compliance/List.svelte'
import Assets from './Compliance/Assets.svelte'
import PirView from './PirView.svelte'
import Guest from './Covid/Guest.svelte'
import Staff from './Covid/Staff.svelte'
import Thankyou from './Covid/Thankyou.svelte'
import Qrcode from "./Tools/Qrcode.svelte" 
export default {
    '/':Home,
    '/login':Login,
    '/dashboard':Dashboard,
    '/pir/edit/*':Pir,
    '/pir/create/:customer':Pir,
    '/pir/view/*':PirView,
    '/customer/:customer?':Customer,
    '/compliance/checklist':Checklist,
    '/compliance/checklist/list':List,
    '/compliance/assets':Assets,
    '/compliance/checklist/*':Checklist,
    '/covid/guest':Guest,
    '/covid/member':Staff,
    '/covid/thankyou':Thankyou,
    '/tools/qrcode':Qrcode,
    '*':Ahh
}
 
